import { createGlobalStyle } from 'styled-components';
import { StyleConstant } from 'util/getStyleConstant';
import { CEB_COLOR, CEB_COLOR_RGBA } from 'app-constants/CEB_COLOR';

export const StyledGlobalApp = createGlobalStyle`
  * {
    background: transparent;
    color: inherit;
    margin: 0;
    padding: 0;
    :not(table, td, th){
      border: 0;
    }
    &:focus {
      outline-color: ${CEB_COLOR_RGBA('DANUBE', 0.6)};
      outline-style: solid;
      outline-width: 1px;
    }
  }

  body {
    background-color: rgb(248, 247, 245);
    font-family: 'Zilla Slab', serif;
    color: ${CEB_COLOR('BLACK')};
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100vh;
    @media only print {
      background-color: white;
    }
  }

  html,
  body,
  #root {
    @media screen and (min-width: ${StyleConstant.BREAKPOINT_HANDHELD}) {
      height: 100vh;
      overflow: auto;
      width: 100vw;
    }
  }
  
  ::-moz-selection{
    background: ${CEB_COLOR_RGBA('#cfe3e6', 0.99)};
  }

  ::selection {
    background: ${CEB_COLOR_RGBA('#cfe3e6', 0.99)};
  }

  input[type='checkbox'] {
    &:focus {
      outline: none;
      box-shadow: 0 0 0 1px ${CEB_COLOR_RGBA('DANUBE', 0.6)};
    }
  }

  button, label {
    cursor: pointer;
    &[disabled]{
      cursor: default;
    }
  }

  a,
  a:visited {
    color: ${CEB_COLOR('NICE_BLUE')};
    text-decoration: none;
    &:focus {
      border-bottom: 1px solid ${CEB_COLOR_RGBA('DANUBE', 0.6)};
      margin-bottom: -1px;
      outline: 0;
    }
  }
`;
